// Constants
import { CLIENT_PORTFOLIO, BENCHMARK_PORTFOLIO, CEF, ETF, STOCK, MODEL_PORTFOLIO, MULTI_WATCHLIST, STOCK_SAVED_SCREEN, FUND_SAVED_SCREEN, STRATEGY, COMPANY, INDEX, INDICATOR, INDICATOR_WATCHLIST, MUTUAL_FUND, SEPARATE_ACCOUNT, } from 'NewAngular/constants/core.constants';
// Modal operators
export const ALERTS_GREATER_THAN_OR_EQUAL_TO_OPERATOR = '>=';
export const ALERTS_LESS_THAN_OR_EQUAL_TO_OPERATOR = '<=';
// Metric selector autocomplete regex
export const ALERTS_SEARCH_BLOCK_REGEX = '-?(?:[0-9]*\\.[0-9]+|[0-9]+\\.?)(?:k|m|b|t|q|%|K|M|B|T|Q)?';
// Metric selector event name
export const ALERTS_GREATER_THAN_OR_EQUAL_STRING_VALUE = 'gte';
export const ALERTS_LESS_THAN_OR_EQUAL_STRING_VALUE = 'lte';
// Alerts List dropdown config
export const ALERTS_OPERATOR_CONFIG = {
    title: {
        label: '',
    },
    list: [
        {
            label: ALERTS_LESS_THAN_OR_EQUAL_TO_OPERATOR,
            value: ALERTS_LESS_THAN_OR_EQUAL_STRING_VALUE,
        },
        {
            label: ALERTS_GREATER_THAN_OR_EQUAL_TO_OPERATOR,
            value: ALERTS_GREATER_THAN_OR_EQUAL_STRING_VALUE,
        },
    ],
};
// Field selector event name
export const ALERTS_INDICATOR_VALUE = 'last_value';
// Indicator Alerts List dropdown config
export const ALERTS_INDICATOR_FIELD_OPTIONS_CONFIG = {
    title: {
        label: '',
        icon: null,
    },
    list: [
        {
            disabled: false,
            icon: null,
            label: 'Value',
            type: 'option',
            value: 'last_value',
        },
        {
            disabled: false,
            icon: null,
            label: '% Chg from Previous',
            type: 'option',
            value: 'last_change_percent',
        },
        {
            disabled: false,
            icon: null,
            label: '% Chg from 1Y Ago',
            type: 'option',
            value: 'change_year_ago_percent',
        },
    ],
};
// constants used to determine which alerts edit modal to open
export const METRIC_AND_SYSTEM_ALERT_SUPPORTED_OBJECTS = new Set([
    COMPANY,
    INDEX,
    INDICATOR,
    INDICATOR_WATCHLIST,
    MODEL_PORTFOLIO,
    MULTI_WATCHLIST,
    MUTUAL_FUND,
    SEPARATE_ACCOUNT,
]);
export const SINGLE_SYSTEM_ALERT_SUPPORTED_OBJECTS = new Set([
    STOCK_SAVED_SCREEN,
    FUND_SAVED_SCREEN,
    STRATEGY,
]);
export const SECURITY_ALERT_OBJECT_TYPES = new Set([
    COMPANY,
    INDEX,
    INDICATOR,
    MODEL_PORTFOLIO,
    MUTUAL_FUND,
    SEPARATE_ACCOUNT,
]);
// Metric alert types
export const METRIC_ALERT_LIMIT = 'limit';
// System alert types
export const SYSTEM_ALERT_FINANCIAL_DATA = 'financial_data';
export const SYSTEM_ALERT_EVENTS = 'events';
export const SYSTEM_ALERT_NEWS = 'news';
export const SYSTEM_ALERT_OVERALL_RATING = 'overall_rating';
export const SYSTEM_ALERT_VALUE_SCORE = 'value_score';
export const SYSTEM_ALERT_FUNDAMENTAL_SCORE = 'fundamental_score';
export const SYSTEM_ALERT_STRATEGY = 'strategy';
export const SAVED_SCREEN_ALERT = 'saved_screen';
export const STRATEGY_ALERT = 'strategy';
export const SYSTEM_ALERTS_OPTIONS = [
    {
        description: 'New Financial Statement data is available for this stock',
        modelPortfolioDescription: 'New Financial Statement data is available for one or more holdings',
        watchlistDescription: 'New Financial Statement data is available for stocks on this watchlist',
        supportedDetailedTypes: [STOCK, CLIENT_PORTFOLIO, BENCHMARK_PORTFOLIO, MODEL_PORTFOLIO, MULTI_WATCHLIST],
        alertType: SYSTEM_ALERT_FINANCIAL_DATA,
    },
    {
        description: 'New Events (Earnings, Dividends, etc.) are available for this stock',
        modelPortfolioDescription: 'New Events (Earnings, Dividends, etc.) are available for one or more holdings',
        watchlistDescription: 'New Events (Earnings, Dividends, etc.) are available for stocks on this watchlist',
        supportedDetailedTypes: [
            CEF,
            ETF,
            STOCK,
            CLIENT_PORTFOLIO,
            BENCHMARK_PORTFOLIO,
            MODEL_PORTFOLIO,
            MULTI_WATCHLIST,
        ],
        alertType: SYSTEM_ALERT_EVENTS,
    },
    {
        description: 'New News is available for this stock',
        modelPortfolioDescription: 'New News is available for one or more holdings',
        watchlistDescription: 'New News is available for stocks on this watchlist',
        supportedDetailedTypes: [
            CEF,
            ETF,
            STOCK,
            CLIENT_PORTFOLIO,
            BENCHMARK_PORTFOLIO,
            MODEL_PORTFOLIO,
            MULTI_WATCHLIST,
        ],
        alertType: SYSTEM_ALERT_NEWS,
    },
    {
        description: 'Pro Y-Rating changes',
        modelPortfolioDescription: 'Pro Y-Rating changes for one or more holdings',
        watchlistDescription: 'Pro Y-Ratings change for stocks on this watchlist',
        supportedDetailedTypes: [STOCK, CLIENT_PORTFOLIO, BENCHMARK_PORTFOLIO, MODEL_PORTFOLIO, MULTI_WATCHLIST],
        alertType: SYSTEM_ALERT_OVERALL_RATING,
    },
    {
        description: 'Pro Value Score changes',
        modelPortfolioDescription: 'Pro Value Score changes for one or more holdings',
        watchlistDescription: 'Pro Value Scores change for stocks on this watchlist',
        supportedDetailedTypes: [STOCK, CLIENT_PORTFOLIO, BENCHMARK_PORTFOLIO, MODEL_PORTFOLIO, MULTI_WATCHLIST],
        alertType: SYSTEM_ALERT_VALUE_SCORE,
    },
    {
        description: 'Pro Fundamental Score changes',
        modelPortfolioDescription: 'Pro Fundamental Scores changes for one or more holdings',
        watchlistDescription: 'Pro Fundamental Scores change for stocks on this watchlist',
        supportedDetailedTypes: [STOCK, CLIENT_PORTFOLIO, BENCHMARK_PORTFOLIO, MODEL_PORTFOLIO, MULTI_WATCHLIST],
        alertType: SYSTEM_ALERT_FUNDAMENTAL_SCORE,
    },
    {
        description: 'Stock enters or exits any Investment Strategy',
        modelPortfolioDescription: 'Investment Strategy changes for one or more holdings',
        watchlistDescription: 'Stocks in this watchlist enter or exit any Investment Strategy',
        supportedDetailedTypes: [STOCK, CLIENT_PORTFOLIO, BENCHMARK_PORTFOLIO, MODEL_PORTFOLIO, MULTI_WATCHLIST],
        alertType: SYSTEM_ALERT_STRATEGY,
    },
];
// Alert list fetch status
export const ALERT_FETCH_SUCCESS = 'success';
export const ALERT_FETCH_PENDING = 'pending';
export const ALERT_FETCH_ERROR = 'error';
// Metric autocomplete placeholders
export const LEFT_METRIC_PLACEHOLDER = 'Enter Metric';
export const RIGHT_METRIC_PLACEHOLDER = 'Enter Metric or Value';
// Metric alert action options
export const METRIC_ALERT_ACTIONS_CONFIG = {
    title: {
        label: '',
        icon: 'icon-dots-more',
    },
    list: [
        {
            type: 'option',
            label: 'Share',
            value: 'share',
            icon: 'icon-share',
            disabled: false,
        },
        {
            type: 'option',
            label: 'Disable',
            value: 'toggleDisabled',
            icon: 'icon-password-no-show',
            disabled: false,
        },
        {
            type: 'option',
            label: 'Delete',
            value: 'delete',
            icon: 'icon-delete',
            disabled: false,
        },
    ],
};
